export default __webpack_public_path__ + "static/media/ic_taiwan.36f9d7a2.svg";